module.exports = __webpack_public_path__ + "img/M0013.0e46d4c1.png";